module.exports = __webpack_public_path__ + "img/Partners 2.b15e3e98.png";